var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.option.hide)?_c('div',{class:_vm.setClass(),style:(_vm.styleSize)},[(_vm.option.source)?_c('iframe',{class:_vm.setClass('wrapper'),attrs:{"src":_vm.option.source,"draggable":"false"},on:{"load":_vm.loaded}}):_c('div',{staticClass:"drag-empty",style:(_vm.styleVisible)})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }